import { createContext } from 'react'

export const ExercisesContext = createContext(null)
